import React from 'react';
import { T as Typography } from './Typography-BUVIUAC9.js';
import { I as Icon } from './Icon-8KKXFsxm.js';
import { u as useDataListLayoutActionsContext } from './DataListLayoutContext-B-xNSmCX.js';

var styles = {"action":"iyg43v-S9yU-","label":"AUJNqz93ZDA-"};

function DataListAction({ label, icon, destructive, visible = () => true, onClick, }) {
    const { activeItem } = useDataListLayoutActionsContext();
    // Don't render if the item is not visible
    if (activeItem && !visible(activeItem)) {
        return null;
    }
    const color = destructive ? "critical" : "heading";
    function getActionLabel() {
        if (typeof label === "string") {
            return label;
        }
        if (activeItem) {
            return label(activeItem);
        }
    }
    return (React.createElement("button", { type: "button", className: styles.action, onClick: handleClick },
        React.createElement(Typography, { textColor: color },
            React.createElement("span", { className: styles.label }, getActionLabel())),
        icon && React.createElement(Icon, { name: icon, color: color })));
    function handleClick() {
        if (activeItem) {
            onClick === null || onClick === void 0 ? void 0 : onClick(activeItem);
        }
        else {
            onClick === null || onClick === void 0 ? void 0 : onClick();
        }
    }
}

export { DataListAction as D };
